import getStore, { CopilotCatchUpState } from '../store/store';

export function isCopilotCatchUpStarted() {
    return getStore().catchUpState !== CopilotCatchUpState.NotStarted;
}
